import { Auth } from 'aws-amplify';
import { type LoaderFunctionArgs, matchPath, redirect } from 'react-router-dom';

import { API_STATUS_CODE } from '@/constants/api.constants';
import {
  FEATURE_PRIVATE_ROUTES,
  ROUTES_PATH,
} from '@/constants/routes.constants';
import { getPathnameFromUrl, getUserInformation } from '@/helpers/auth.helper';

export async function loader({ request }: LoaderFunctionArgs) {
  const pathname = getPathnameFromUrl(request.url);
  try {
    await Auth.currentSession();
    const { role } = getUserInformation();
    const hasAccessRoute = FEATURE_PRIVATE_ROUTES[role!].some(route =>
      matchPath(route, pathname),
    );
    if (hasAccessRoute) return true;
    throw new Response('Not Found', { status: API_STATUS_CODE.notFound });
  } catch (error) {
    if (error instanceof Response) throw error;
    const pathnameIncludeSearch = getPathnameFromUrl(request.url, true);
    return redirect(
      pathname === ROUTES_PATH.root
        ? ROUTES_PATH.login
        : `${ROUTES_PATH.login}?redirect_url=${pathnameIncludeSearch}`,
    );
  }
}
